import { GridColDef } from "@mui/x-data-grid-pro";
import { GKClientDataGrid, Grid2, StatusField, Typography } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { RevenueManagerDetails } from "interfaces/Revenue";
import { removeUnderscoreAndFirstLetterCapital } from "utils";
import { extraColumnsField } from "utils/helpers";

interface Props {
  feePlanDetails: RevenueManagerDetails;
  rowSelectionModel: string[] | number[];
  setRowSelectionModel: (rowSelectionModel: string[]) => void;
}

const FeePlansTab = (props: Props) => {
  const { feePlanDetails, rowSelectionModel, setRowSelectionModel } = props;

  const { data, isFetching } = useFetchQuery({
    key: ["PORTFOLIO_FEE_PLANS"],
    route: `/api/revenue/fee-plan/`,
    success: () => {
      setRowSelectionModel(
        feePlanDetails?.feePlan?.feePlanId
          ? [feePlanDetails?.feePlan?.feePlanId]
          : [],
      );
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField(
        `Fee Plan (${data?.data?.totalCount})`,
        "name",
        150,
        1,
      ),
    },
    {
      ...extraColumnsField("Revenue Products", "revenueProducts", 150, 1),
      valueGetter: (params) =>
        params?.row?.revenueProducts.map((dataItem: string) =>
          removeUnderscoreAndFirstLetterCapital(dataItem),
        ),
    },
  ];

  return (
    <Grid2 size={12} container spacing={3}>
      <Grid2
        size={12}
        p={"12px 16px"}
        borderRadius={2}
        bgcolor={"var(--grey-bg-100)"}
        display={"flex"}
        alignItems={"center"}
        gap={1}
      >
        <Typography fontWeight={500} color="var(--grey-900)">
          {feePlanDetails?.feePlan?.feePlanName}
        </Typography>
        <StatusField
          statusString="CURRENT PLAN"
          styles={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid var(--white)",
            background: "var(--success-100)",
            fontSize: 12,
            fontWeight: 600,
            color: "var(--success-700)",
          }}
        />
      </Grid2>
      <Grid2 size={12}>
        <GKClientDataGrid
          density="compact"
          checkboxSelection
          disableRowSelectionOnClick
          // onRowSelectionModelChange={(params) => {
          //   const selection = Array.isArray(params)
          //     ? [params[params.length - 1]]
          //     : [];
          //   setRowSelectionModel(selection.map(String));
          // }}
          onRowSelectionModelChange={(params) => {
            if (!params || params.length === 0) {
              setRowSelectionModel([]);
              return;
            }

            setRowSelectionModel([String(params[params.length - 1])]);
          }}
          showHeaderGrid={false}
          rowSelectionModel={rowSelectionModel}
          isRowSelectable={() => true}
          loading={isFetching}
          columns={columns}
          rows={data?.data?.data || []}
          name="portfolioFeePlans"
          sx={{
            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-checkboxInput": {
              display: "none",
            },
          }}
          maxHeight={"calc(100vh - 606px)"}
        />
      </Grid2>
    </Grid2>
  );
};

export default FeePlansTab;
